/* Rhode Header JS — two mega-menu triggers + mobile drawer + tab switching */
(function () {
  'use strict';

  var megaMenu   = document.getElementById('rhode-mega-menu');
  var closeTimer = null;

  /* ─── Open / close helpers ──────────────────── */
  function openSection(sectionId) {
    if (!megaMenu) return;
    clearTimeout(closeTimer);
    /* Drive visibility via CSS [data-active-section] selector, not inline styles */
    megaMenu.dataset.activeSection = sectionId;
    megaMenu.classList.add('is-open');
  }

  function scheduleClose() {
    closeTimer = setTimeout(function () {
      if (megaMenu) megaMenu.classList.remove('is-open');
    }, 150);
  }

  function cancelClose() {
    clearTimeout(closeTimer);
  }

  /* ─── Bind each trigger ─────────────────────── */
  var triggers = document.querySelectorAll('[data-rh-mega-trigger]');

  triggers.forEach(function (trigger) {
    var sectionId = trigger.dataset.rhMegaTrigger;
    trigger.addEventListener('mouseenter', function () { openSection(sectionId); });
    trigger.addEventListener('mouseleave', scheduleClose);
    trigger.addEventListener('focus',      function () { openSection(sectionId); });
  });

  if (megaMenu) {
    megaMenu.addEventListener('mouseenter', cancelClose);
    megaMenu.addEventListener('mouseleave', scheduleClose);

    /* ─── Desktop tab switching (Papeterie section only) ── */
    var mmTabs   = megaMenu.querySelectorAll('.rhode-mm-tab');
    var mmPanels = megaMenu.querySelectorAll('.rhode-mm-panel');

    function activateTab(cat) {
      mmTabs.forEach(function (t) {
        t.classList.toggle('is-active', t.dataset.category === cat);
      });
      mmPanels.forEach(function (p) {
        p.classList.toggle('is-active', p.dataset.category === cat);
      });
    }

    mmTabs.forEach(function (tab) {
      tab.addEventListener('mouseenter', function () { activateTab(tab.dataset.category); });
      tab.addEventListener('click',      function () { activateTab(tab.dataset.category); });
    });
  }

  /* ─── Mobile menu ───────────────────────────── */
  var hamburger  = document.querySelector('.rhode-hamburger');
  var closeBtn   = document.querySelector('.rhode-mobile-menu__close');
  var mobileMenu = document.querySelector('.rhode-mobile-menu');
  var overlay    = document.querySelector('.rhode-overlay');

  function openMobile() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeMobile() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (hamburger) hamburger.addEventListener('click', openMobile);
  if (closeBtn)  closeBtn.addEventListener('click',  closeMobile);
  if (overlay)   overlay.addEventListener('click',   closeMobile);

  /* Mobile tab switching */
  if (mobileMenu) {
    var mobileTabs   = mobileMenu.querySelectorAll('.rhode-mobile-tab');
    var mobilePanels = mobileMenu.querySelectorAll('.rhode-mobile-panel');

    mobileTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var cat = tab.dataset.category;
        mobileTabs.forEach(function (t)   { t.classList.toggle('is-active',   t.dataset.category === cat); });
        mobilePanels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.category === cat); });
      });
    });
  }

})();
